var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutsideAntenna01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.52,
    y: 1.32,
    className: "st2",
    width: 0.5,
    height: 13.36
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.93,
    y: 5.01,
    className: "st2",
    width: 11.76,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.89,
    y: 5.39,
    className: "st2",
    width: 9.84,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.25,
    y: 6.01,
    className: "st2",
    width: 7.3,
    height: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.87,
    y: 3.74,
    className: "st2",
    width: 5.54,
    height: 0.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.26,13.48c0,0.7-0.48,1-0.94,1c-0.51,0-0.91-0.38-0.91-0.97c0-0.63,0.41-1,0.94-1 C10.89,12.5,11.26,12.9,11.26,13.48z M9.76,13.5c0,0.41,0.24,0.73,0.57,0.73c0.33,0,0.57-0.31,0.57-0.73 c0-0.32-0.16-0.73-0.57-0.73S9.76,13.14,9.76,13.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.27,13.92c0,0.2,0,0.37,0.02,0.52h-0.3l-0.02-0.31h-0.01c-0.09,0.15-0.29,0.35-0.62,0.35 c-0.3,0-0.65-0.16-0.65-0.83v-1.11h0.34v1.05c0,0.36,0.11,0.6,0.42,0.6c0.23,0,0.39-0.16,0.45-0.31c0.02-0.05,0.03-0.11,0.03-0.18 v-1.16h0.34V13.92z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.26,12v0.54h0.49v0.26h-0.49v1.02c0,0.23,0.07,0.37,0.26,0.37c0.09,0,0.16-0.01,0.2-0.02l0.02,0.26 c-0.07,0.03-0.17,0.05-0.3,0.05c-0.16,0-0.29-0.05-0.37-0.14c-0.1-0.1-0.13-0.27-0.13-0.49v-1.03h-0.29v-0.26h0.29v-0.45L14.26,12 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutsideAntenna01);
export default __webpack_public_path__ + "static/media/OutsideAntenna-01.adb0ed5be38b9fbbd40d859df229ca27.svg";
export { ForwardRef as ReactComponent };